import alternativeLocales from './alternative-locales';

export default ['en-US', ...alternativeLocales];
